import * as React from "react"

import { cn } from "#/lib/utils"

function Input({
  className,
  type,
  ...props
}) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "h-8 w-full min-w-0 rounded-sm border border-gray-300 bg-transparent px-2.5 py-1 text-base text-gray-700 transition-colors outline-none file:inline-flex file:h-6 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground hover:border-primary-500 hover:ring-1 hover:ring-primary-500/35 focus-visible:border-primary-500 focus-visible:ring-1 focus-visible:ring-primary-500/35 disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-input/50 disabled:opacity-50 read-only:hover:border-gray-300 read-only:hover:ring-0 aria-invalid:border-red-500 aria-invalid:ring-1 aria-invalid:ring-red-500/35 aria-invalid:hover:border-red-500 aria-invalid:hover:ring-red-500/35 aria-invalid:focus-visible:border-red-500 aria-invalid:focus-visible:ring-red-500/35 md:text-sm dark:bg-input/30 dark:disabled:bg-input/80",
        className
      )}
      {...props} />
  );
}

export { Input }
